import '../stylesheets/AboutPage.css';

export function AboutPage() {
    return (
        <div className='AboutPage'>
            <div className='text-container'>
                <h1>ՄԵՐ ՄԱՍԻՆ</h1>

                <p>
                    Մեր Եկեղեցին կոչվում է «Ավետարանի հավատքի քրիստոնյաների միացյալ եկեղեցի», կրճատ՝ ԱՀՔՄԵ:
                    Մեր եկեղեցու հավամտամքը՝ հիմնված Աստծու Խոսքի վրա, պատրաստվել է ԱՀՔՄԵ-ի Ղեկավարող
                    միության կողմից 1926 թվականին: Միությունը գլխավորում էր Իվան Ե‎‎ֆիմովիչ Վորոնաեւը (1885թ.):
                    Իվան Ե‎‎ֆիմովիչ Վորոնաեւի մասին կարող եք կարդալ ,,Посланник Пятидесятницы
                    (“Иван Воронаев и сподвижники”, Книга 1, Винница, 2007) գրքում:
                </p>
                <p>
                    Մեր եկեղեցու անդամների մեծ մասը մկրտվում են Սուրբ Հոգով: Սուրբ հոգով մկրտվելու մասին առաջին
                    լուրերը Ռուսաստան ներթափանցեցին Նորվեգիայից, Շվեդիայից, Ֆինլանդիայից եւ Մերձբալթյան երկրներից:
                    «Ավատարանական հավատքի քրիստոնյաներ» ուղղությունը Սովետների երկրում սկիզբ առավ Օդեսայի
                    ԱՀՔ եկեղեցուց: 1921 թվականի օգոստոսին Իվան Եֆիմովիչ Վորոնաեւը եւ Վասիլի Ռոմանովիչ
                    Կոլտովիչը գնացին Օդեսա: Վորոնաեւը մի մարդ էր, ում Աստված կանչել էր Սովետների երկրում
                    ավետարանի բարի լուրը տարածելու համար: Նա հաճախ էր ճամփորդում, երբեմն` ծոմերով, երբեմն`
                    քաղցած,  մշտապես հետապնդվում էր պետական անվտանգության աշխատակիցները կողմից:
                    Նրան միշտ սպասում էր բանտն ու աքսորը: Իվան Վորոնաեւի կյանքն ավարտվեց տանջալի մահով.
                    բանտում գտնված ժամանակ Վորոնաեւ եղբոր վրա բաց թողեցին հատուկ պատրաստված շներ եւ
                    գնդակահարեցին նրան, երբ կատաղած շները պատառոտում էին նրա մարմինը:
                </p>
                <p>
                    Իվան Ե‎‎ֆիմովիչ Վորոնաեւի կյանքը մեզ բոլորիս տալիս է հավատքի հրաշալի մի օրինակ`
                    նմանվելու նրան ինչպես կյանքում, այնպես էլ չարչարանքների մեջ: Փառք Աստծուն: Վորոնաեւի,
                    Կոլտովիչի եւ շատ այլ եղբայրների թողած ժառանգությունը եւ Սուրբ Հոգու մկրտության
                    խոսքը շարունակեցին եղբայրներ Գ.Գ.Պանուրկոն, Ա.Ի.Բիդաշը, Ի.Ա.Լեւչուկը,
                    Վ.Ի.Բելիխը եւ այլ օրհնյալ եղբայրներ: Նրանք իրենց կյանքի զգալի մասը` 25 եւ
                    ավելի տարիներ անցկացրին Սովետական Միության բանտերում` հավատքի համար,
                    մեծ գին վճարեցին` մասնակից լինելով Քրիստոսի չարչարանքներին:
                </p>
                <p>
                    Մեզ մոտ` Հայաստանում, առաջին դարից` Աբգար թագավորի ժամանակներից սկսած,
                    հետագա բոլոր դարերում ու մինչեւ այսօր, Աստված ունի Իր զավակները եւ Իր Սուրբ
                    Հոգով մկրտված եկեղեցին: Բայց այս վերջին տարիներին, մոտ հիսուն տարի առաջ,
                    1960 թվականից Աստված մի նոր արթնություն սկսեց Հայաստանում:
                    Այդ նպատակի համար Աստված Ռուսաստանի Լենինգրադ քաղաքից ուղարկեց Սերգեյ
                    Կեվորկով եղբորը, եւ Հայաստանում սկսվեց արթնությունը: Սերգեյ եղբայրը  ծնվել է
                    Ռուսաստանի Արմավիր քաղաքում, դպրոցական տարիներին ընդունել է Աստծու Խոսքը,
                    մկրտվել Սուրբ հոգով:
                </p>
                <p>
                    Սկզբնական շրջանում արթնության ալիքը տարածվեց Երեւանի հատուկ ֆիզիկա-մաթեմատիկական դպրոցում:
                </p>
                <p>
                    Երկրաշարժից հետո` 90-ական թվականներին, արթնության մի նոր ու լայն ալիք տարածվեց Հայաստանում:
                    Մարդիկ գալիս ու մասնակցում էին Երեւանի «Փարոս» կոչվող վայրում մեր եկեղեցու կողմից կազմակերպված
                    հավաքույթներին, լսում էին կենդանի Աստծու Խոսքը, կատարվում էին շատ  հրաշքներ` մարդիկ ազատագրվում
                    էին սթրեսներից, դիվական ուժերի ներգործություններից, մարմնավոր ու հոգեւոր բժշկություններ  էին ստանում:
                </p>
                <p>
                    Հետագայում արթնության այդ ալիքը մարեց, սակայն չվերջացավ ու շարունակվում է մինչեւ այսօր:
                </p>
                <p>
                    Հայաստանի անկախանալուց հետո արտասահմանից մեր եկեղեցի այցելեցին հյուրեր, որոնք շատ մեծ
                    վնաս հասցրին մեր եկեղեցուն: Օգտվելով այդ ժամանակվա տնտեսական ծանր կացությունից`
                    նրանք եկեղեցու տկար հոգիների մեջ սերմանեցին մոլորյալ ուսմունքներ եւ մեր եկեղեցին մասերի բաժանեցին:
                </p>
                <p>
                    Քրիստոսի Եկեղեցին իր կենսագրության երկու հազար տարիների ընթացքում բազմաթիվ փորձություններ,
                    հետապնդումներ կրեց, հոգեպես տկարացավ ու շեղվեց վաղ շրջանի առաքելական ծառայությունից,
                    բայց Գողգոթայում մահացած Քրիստոսն Իր զորությամբ վերածնեց նրան եւ տանում է կատարելության:
                    Այժմ Եկեղեցին պատրաստվում է հափշտակության: «Հիմա՛ եկուր, Տե՛ր Հիսուս»: Ամեն:
                </p>
            </div>
        </div>
    )
}
